import { FC } from "react";
import {
  ExpandableSearchBar,
  ExpandableSearchBarProps,
} from "@jugl-web/ui-components/web/ExpandableSearchBar";
import { useCustomersContext } from "../../providers/useCustomersContext";
import { CustomerSearchQueryFiltersPopover } from "../CustomerSearchSettingsPopover/CustomerSearchSettingsPopover";

export const CustomerSearchBar: FC<{
  entityId: string;
  color?: ExpandableSearchBarProps["color"];
  className?: string;
  onReset?: () => void;
  onSearch?: (value?: string) => void;
}> = ({ entityId, color, className, onReset, onSearch }) => {
  const { searchQuery, setSearchQuery, queryFilters } = useCustomersContext();
  const handleSearchQuery = (value: string) => {
    setSearchQuery(value);
    onSearch?.(value);
  };
  return (
    <ExpandableSearchBar
      size="lg"
      color={color || "white"}
      onSearch={handleSearchQuery}
      onReset={onReset}
      defaultValue={searchQuery}
      isAlwaysExpanded
      hasSettingsIndicator={queryFilters.length > 0}
      className={className}
      settingsPopover={
        <CustomerSearchQueryFiltersPopover entityId={entityId} />
      }
    />
  );
};
